export const PAGE_SIZE_OPTIONS = ['12', '20', '48']
export const TOTAL_PAGE = 48;